import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const getAllIpRestrictionsApi = async (params = {}) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.IP.GET_ALL,
    params,
  });
};

// payload shape must be:
// {
//   coll: "IpWhitelist",
//   payload: {
//     organizationId,
//     ipAddress,
//     role,
//     status,
//     addedBy,
//   }
// }
export const addIpRestrictionApi = async (body) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.IP.ADD,
    data: body,
  });
};

// params shape must be:
// {
//   coll: "IpWhitelist",
//   uiid,
//   payload: {
//     $set: { status, ipAddress }
//   }
// }
export const updateIpRestrictionApi = async (params) => {
  const { coll, uiid, payload } = params;
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.IP.UPDATE,
    data: {
      coll,
      uiid,
      payload,
    },
  });
};

// params shape: { coll: "IpWhitelist", uiid }
export const deleteIpRestrictionApi = async (params) => {
  const { coll, uiid } = params;
  return await axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.IP.DELETE,
    data: {
      coll,
      uiid,
    },
  });
};

